import { render, staticRenderFns } from "./VendorAccounts.vue?vue&type=template&id=664c44ea"
import script from "./VendorAccounts.vue?vue&type=script&lang=js"
export * from "./VendorAccounts.vue?vue&type=script&lang=js"
import style0 from "./VendorAccounts.vue?vue&type=style&index=0&id=664c44ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports